import React, { useEffect, useState } from 'react';
import Status from '../../../core/types/Status';
import Modal from '../../../core/components/Modal/Modal';
// @ts-ignore
import styles from './PayAllTile.module.scss';
import ApiProvider from '../../../core/api/ApiProvider';
import { Loader, ModuleContainer } from '../../../core/components';
import { PaymentProviderType } from '../../types/PaymentProviderType';
import { PaymentProviderListVM } from '../../types/PaymentProviderListVM';
import { InfoMessageService, TranslationService } from '../../../core/services';
import { PayableItem } from './types/PayableItem';

type Props = {
  selectedItem: PayableItem;
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
  onPay: (providerId: PaymentProviderType) => void;
};

const ProvidersModal = (props: Props) => {
  const { isOpen, onToggle, onPay } = props;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [model, setModel] = useState<PaymentProviderListVM>({} as PaymentProviderListVM);

  const getAvailablePaymentProviders = async () => {
    return await ApiProvider.get<Status<PaymentProviderListVM>>(
      `PayAllTileModule/GetAvailablePaymentProviders`
    );
  };

  const fetchData = async () => {
    try {
      const data = await getAvailablePaymentProviders();
      setModel(data.data);
      if (!data.success) {
        InfoMessageService.error(data.message);
        onToggle(false);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onToggle={onToggle}
        className={styles.modalWrapper}
        closeBtnClass="modal-close-btn"
      >
        <ModuleContainer classNames="mt-0 mb-0" variant={ModuleContainer.ModuleVariant.Variant1}>
          <ModuleContainer.Header title={TranslationService.translate('ChooseProvider')} />
          {isLoading && <Loader opacity={0.4} />}
          <ModuleContainer.Body variant={ModuleContainer.Body.BodyVariant.Primary}>
            <div className={styles.grid}>
              {model.paymentProviders &&
                model.paymentProviders.map((provider) => {
                  return (
                    <button
                      key={provider.type}
                      onClick={() => {
                        setIsLoading(true);
                        onPay(provider.type);
                      }}
                      id={`PayWith_${PaymentProviderType[provider.type]}`}
                      className={styles.providersTile}
                      disabled={isLoading}
                      data-cy={provider.type}
                    >
                      <img
                        src={provider.logo}
                        className={styles.providersLogo}
                        alt="Logo"
                        data-cy={`PaymentProviderEnum-${provider.type}`}
                      />
                    </button>
                  );
                })}
            </div>
          </ModuleContainer.Body>
        </ModuleContainer>
      </Modal>
    </>
  );
};

export default ProvidersModal;
